'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'tree';
var width = 448;
var height = 512;
var aliases = [127794];
var unicode = 'f1bb';
var svgPathData = ['M2.2 434.1C6.1 442.6 14.6 448 24 448l168 0 0-224c0-17.7 14.3-32 32-32s32 14.3 32 32l0 224 168 0c9.4 0 17.9-5.4 21.8-13.9s2.6-18.5-3.5-25.6L353.5 304 392 304c9.4 0 17.9-5.4 21.8-13.9s2.6-18.5-3.5-25.6L335.1 176 360 176c9.4 0 17.9-5.4 21.8-13.9s2.6-18.5-3.5-25.6l-136-160C237.7-28.9 231-32 224-32s-13.7 3.1-18.3 8.5l-136 160c-6.1 7.1-7.4 17.1-3.5 25.6S78.6 176 88 176l24.9 0-75.2 88.5c-6.1 7.1-7.4 17.1-3.5 25.6S46.6 304 56 304l38.5 0-88.8 104.5c-6.1 7.1-7.4 17.1-3.5 25.6z', 'M224 192c17.7 0 32 14.3 32 32l0 288c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-288c0-17.7 14.3-32 32-32z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTree = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;